export class Auth0Vars {
  static AUTH0_CLIENT_ID = 's6n0298IOOaflMXAMjZjzRueCQG5a_3K';
  static AUTH0_DOMAIN = 'voltio.au.auth0.com';
  static AUTH0_CALLBACK_URL = location.href;
}


// WEBPACK FOOTER //
// ./src/auth0-variables.ts